/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.multi.account.crm.manager.rpc.MultiAccountCrmManagerChirpService
 */

export const getCompanyRelatedAccountsRpc = {
  serviceName: 'com.hubspot.multi.account.crm.manager.rpc.MultiAccountCrmManagerChirpService',
  rpcName: 'getCompanyRelatedAccounts',
  auth: 'app',
  fingerprint: 'L9-53sbsykEvfm5Jn8wh1ohWDgsn_q0K',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getCompanyAssociatedDealsRpc = {
  serviceName: 'com.hubspot.multi.account.crm.manager.rpc.MultiAccountCrmManagerChirpService',
  rpcName: 'getCompanyAssociatedDeals',
  auth: 'app',
  fingerprint: 'VWNqAHaqmxjO6ENqPvmzHohWDgsn_q0K',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getCompanyAssociatedContactsRpc = {
  serviceName: 'com.hubspot.multi.account.crm.manager.rpc.MultiAccountCrmManagerChirpService',
  rpcName: 'getCompanyAssociatedContacts',
  auth: 'app',
  fingerprint: 'XPn_tWoWFKIyXjdB_MfOT4hWDgsn_q0K',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getCompanyTimelineRpc = {
  serviceName: 'com.hubspot.multi.account.crm.manager.rpc.MultiAccountCrmManagerChirpService',
  rpcName: 'getCompanyTimeline',
  auth: 'app',
  fingerprint: '_ngTQkmZPWJpMiMhm6TIC4hWDgsn_q0K',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getCompanyTimelineMeetingDetailsRpc = {
  serviceName: 'com.hubspot.multi.account.crm.manager.rpc.MultiAccountCrmManagerChirpService',
  rpcName: 'getCompanyTimelineMeetingDetails',
  auth: 'app',
  fingerprint: 'p24OgIwgrMoL5aiw4Yq7eYhWDgsn_q0K',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getCompanyTimelineEmailDetailsRpc = {
  serviceName: 'com.hubspot.multi.account.crm.manager.rpc.MultiAccountCrmManagerChirpService',
  rpcName: 'getCompanyTimelineEmailDetails',
  auth: 'app',
  fingerprint: '8o0wb1zHj09UZrSx_lfH6IhWDgsn_q0K',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const isConnectedCompanyRpc = {
  serviceName: 'com.hubspot.multi.account.crm.manager.rpc.MultiAccountCrmManagerChirpService',
  rpcName: 'isConnectedCompany',
  auth: 'app',
  fingerprint: 'YkWhaH7hTQlx2hyuXYdaWIhWDgsn_q0K',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};